import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" />,
  'Navigation',
);
